import { Tag } from "antd"
import { ArchiveSvg } from "assets/svg/icon"

export const TaskArchivedLabel = (props: React.ComponentProps<typeof Tag>) => {
  return (
    <Tag {...props}>
      <ArchiveSvg />
      <span
        style={{
          marginLeft: '5px',
        }}
      >
        Archived
      </span>
    </Tag>
  )
}